/* eslint-disable react/prop-types */
const FilterButton = ({ title, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 rounded-sm border border-prime-red cursor-pointer transition-all duration-300 ${
        isActive
          ? "bg-prime-red text-zinc-100"
          : "bg-transparent text-prime-red hover:bg-prime-red/10"
      }`}
    >
      {title}
    </button>
  );
};

export default FilterButton;
